import ClaimListing from './ClaimListing';

const ClaimPropertyResponse = ({ totalListingCount = 0, listings = [] } = {}) => ({
  totalListingCount: Number(totalListingCount),
  listings: listings.map(ClaimListing),
});

export default ClaimPropertyResponse;

export type ClaimPropertyResponseProps = ReturnType<typeof ClaimPropertyResponse>;
